export default {
  // 登出接口_志长
  userLogout(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-crm/login/logout',
      params: params,
    });
  },
  // 家长修改个人信息(头像、姓名、电话) 钟军
  parentUpdate(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-crm/parent/update',
      params: params,
    });
  },
  // 我浏览的_李祥达
  companyMyBrowse(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-crm/company/myBrowse',
      params: params,
    });
  },
  // 我浏览的_李祥达
  deleteCompanyMyBrowse(params) {
    return app.http.ajax({
      method: 'delete',
      url: `/cs-crm/company/myBrowse`,
      params: params,
    });
  },
  // 家长端获取用户信息_钟军
  parentGet(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-crm/parent/getLoginInfo',
      params,
    });
  },
  // 家长端获取绑定的学员列表_钟军
  parentGetStudents() {
    return app.http.ajax({
      method: 'get',
      url: '/cs-crm/parent/getStudents',
    });
  },

  // 家长修改学员_钟军
  parentUpdateStudent(params) {
    return app.http.ajax({
      method: 'post',
      url: '/cs-crm/parent/updateStudent',
      params,
    });
  },
  // 家长添加学员_钟军
  parentAddStudent(params) {
    return app.http.ajax({
      method: 'post',
      url: '/cs-crm/parent/addStudent',
      params,
    });
  },

  // 新的添加学员接口_方季惟
  studentAdd(params) {
    return app.http.ajax({
      method: 'post',
      url: '/cs-crm/parent/studentAdd',
      params,
    });
  },

  // 校区列表（免登录）_杨武
  parentGetStudentList(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-crm/parent/getStudentList',
      params,
    });
  },
  // V作业登陆_钟军
  parentGetWeiZuoYeLogin(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-crm/parent/getWeiZuoYeLogin',
      params,
    });
  },

  // 年级-年级列表_钟军
  gradelList() {
    return app.http.ajax({
      method: 'get',
      url: '/cs-crm/grade/list',
    });
  },
  // 查询家长关联的机构-刘鹏
  parentGetCompanyList() {
    return app.http.ajax({
      method: 'get',
      url: '/cs-crm/parent/getCompanyList',
    });
  },
  // 查询家长关联的机构-钟军
  parentUpdateDefaultCompany(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-crm/parent/updateDefaultCompany',
      params,
    });
  },

  // 动态跳转-刘鹏
  getVZuoyeOutSideUrl(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-crm/getVZuoyeOutSideUrl',
      params,
    });
  },

  // 通过机构id获取机构详情
  getShareCompanyDetail(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-crm/company/getShareCompanyDetail',
      params,
    });
  },

  // 获取自定义字段列表——钟军
  getCustomFieldList(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-crm/customField/list',
      params,
    });
  },

  // 获取校区列表_张轶伟
  getCampusList(params) {
    return app.http.ajax({
      method: 'get',
      url: `/cs-crm/campus/list`,
      params: params,
    });
  },
  // 获取学员电子钱包记录_钟军
  getStudentWalletLog(params) {
    return app.http.ajax({
      method: 'post',
      url: '/cs-crm/student/getWalletLog',
      params: params,
    });
  },  
};
